import { getActiveEnvProfile } from "@/utils/utils";
import { Layout } from "antd";
import { Outlet } from "react-router";
import styles from "../../containers/App.module.scss";
import { Header } from "../header/Header";

export const ClientLayout = () => {
  return (
    <Layout className={`${styles.rootLayout} ${getActiveEnvProfile()}`}>
      <Header />

      <Layout.Content className={styles.layoutContent}>
        <Outlet />
      </Layout.Content>
    </Layout>
  );
};
